export interface TableSelection<T> {
  items: T[];
  allPages: boolean;
}
